import { Component, Input, OnInit } from '@angular/core';
import { WidgetsComponentAbstract } from 'src/app/abstract/widgets/widgets-component.abstracts';
import { WidgetsTextModel } from 'src/app/models/widgets/widgets-text.model';
import { WidgetsAbstract } from 'src/app/abstract/widgets/widgets.abstract';
import { Logger } from 'src/app/core/logger';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';
import { WidgetsNotifyDeleteService } from 'src/app/services/widgets/widgets-notify-delete.service';
import { WidgetsSelectionService } from 'src/app/services/widgets/widgets-selection.service';

@Component({
  selector: '[appWidgetsText]',
  templateUrl: './widgets-text.component.html',
  styleUrls: ['./widgets-text.component.scss']
})
export class WidgetsTextComponent extends WidgetsComponentAbstract implements OnInit {
  @Input() data: WidgetsTextModel = new WidgetsTextModel();

  constructor(
    private notifyDeleteService: WidgetsNotifyDeleteService,
    private widgetsService: WidgetsService,
    private selectionService: WidgetsSelectionService,
    private logger: Logger

  ) { super() }

  ngOnInit(): void {
  }

  onDeleteModal(): void {
    this.notifyDeleteService.notifyDelete(this.data);
  }

  clone(WidgetsAbstract: any): WidgetsAbstract {
    throw new Error('Method not implemented.');
  }

  onSelect($event) {
    this.selectionService.toggleSelection(this.data);
  }  
}
